// extracted by mini-css-extract-plugin
export default {"loginForm":"style_loginForm__dVNr1","inputLabel":"style_inputLabel__gY1DZ","label":"style_label__CsN+V"};